// store.js
/* eslint-disable */
import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import VueAxios from 'vue-axios'
import createPersistedState from 'vuex-persistedstate'

const SERVER = "http://dokdo.nolple.com:8000";

const URLgetid = (API_PREFIX, table, id) => `${SERVER}/${API_PREFIX}/${table}/${id}`
const URL = (API_PREFIX, table) => `${SERVER}/${API_PREFIX}/${table}/`
//session api를 위한 url 셋팅
const URLsession = (api, val1) => `${SERVER}/session/${api}/${val1}`
const URLsession2 = (api, val1, val2) => `${SERVER}/session/${api}/${val1}/${val2}`
const URLsession3 = (api, val1, val2, val3) => `${SERVER}/session/${api}/${val1}/${val2}/${val3}`

Vue.use(Vuex)
Vue.use(VueAxios, axios)

export const store = new Vuex.Store({
  plugins: [createPersistedState({
    storage: window.sessionStorage
  })],
  state: {
    //session
    user_name: '',
    user_email: '',
    user_age: '',
    user_image: '',
    session_player: 1,
    session_eventcode: '',
    session_PE: 1,
    session_section: 1,
    session_article: 1,
    session_fwohlist: [],
    session_hashtag: [],
    session_article_state: [],
    session_checklist: [],
    session_section_state: [],
    articles_foredit: [],
    //game
    current_section_id: 1,
    current_article_id: 1,
    current_code: 111,
    articles: [],
    linkArticles: [],
    clues: [],
    fwoh: [],
    sections: ['인물', '지리/영토', '침탈', '역사', '생태/자원', '문화예술'],
    totaltime: 1800,
    totalpoint: 0,
    levelid: 0
  },

  getters: {
    session_player: (state) => {
      return state.session_player
    },
    user_name: (state) => {
      return state.user_name
    },
    user_image: (state) => {
      return state.user_image
    },
    current_section_id: (state) => {
      return state.current_section_id
    },
    session_section: (state) => {
      return state.session_section
    },
    current_article_id: (state) => {
      return state.current_article_id
    },
    session_article: (state) => {
      return state.session_article
    },
    session_PE: (state) => {
      return state.session_PE
    },
    current_section: (state) => {
      return state.sections[state.current_section_id - 1]
    },
    current_section_articles: (state) => {
      return state.articles.filter(article => article.section == state.current_section_id)
    },
    current_article: (state, getters) => {
      return getters.current_section_articles.filter(article => article.id == state.current_article_id)
    },
    current_article_fwoh: (state) => {
      return state.fwoh.filter(fwoh => fwoh.article == state.current_article_id)
    },
    session_hashtag: (state) => {
      return state.session_hashtag
    },
    current_articleLink: (state, getters) => {
      return state.linkArticles.find(link => link.articles.find(item => item == getters.current_article_id))
    },
    current_cluevalue: (state) => {
      const isfind = state.clues.find(clue => clue.identification == state.current_code)
      if (isfind == undefined) {
        return false
      }
      else {
        return isfind.desc
      }
    },
    current_section_article_point: (state, getters) => {
      return state.articles.map(({ id }) => {
        const fwohfiltbyarticleid = state.fwoh.filter(item => item.article == id)
        var initialValue = 0;
        var sum = fwohfiltbyarticleid.reduce(
          (accumulator, currentValue) => accumulator + currentValue.point
          , initialValue)
        return {
          id,
          point: sum
        }
      })
    },
    current_clue: (state, getters) => {
      const isfind = state.clues.find(clue => clue.identification == state.current_code)
      if (isfind == undefined) {
        return false
      }
      else {
        return isfind
      }
    },
    session_fwohlist: (state) => {
      return state.session_fwohlist
    },
    fwohlist: (state, getters) => {
      return getters.current_article_fwoh.map(({ article, given, point, clue }) => {
        const oneclue = state.clues.find(realclue => realclue.id == clue)
        if (given) {
          return {
            article,
            isquest: false,
            point,
            key: oneclue.type,
            value: oneclue.desc,
            code: oneclue.identification,
            clue
          }
        }
        else {
          return {
            article,
            isquest: true,
            point,
            key: oneclue.type,
            value: '',
            code: '',
            clue
          }
        }
      })
    },
    newsGrid: (state, getters) => {
      return getters.current_section_articles.map(({ id, word }, index) => {
        const link = state.linkArticles.find(link => link.articles.find(item => item == id))
        let point = getters.current_section_article_point.find(point => point.id == id)
        if (point.point == 1000) {
          return {
            gridid: index + 1,
            id,
            word,
            pairid: link == null ? 0 : link.id,
            color: link != undefined ? 'PAIR GREEN' : 'GREEN'
          }
        }
        else if (point.point == 800) {
          return {
            gridid: index + 1,
            id,
            word,
            pairid: link == null ? 0 : link.id,
            color: link != undefined ? 'PAIR YELLOW' : 'YELLOW'
          }
        }
        else if (point.point == 600) {
          return {
            gridid: index + 1,
            id,
            word,
            pairid: link == null ? 0 : link.id,
            color: link != undefined ? 'PAIR RED' : 'RED'
          }
        }
        else if (point.point == 300) {
          return {
            gridid: index + 1,
            id,
            word,
            pairid: link == null ? 0 : link.id,
            color: link != undefined ? 'PAIR BLACK' : 'BLACK'
          }
        }
        else {
          return {
            gridid: index + 1,
            id,
            word,
            pairid: 0,
            color: link != undefined ? 'PAIR BLUE' : 'BLUE'
          }
        }
      })
    },
    session_checklist: (state) => {
      return state.session_checklist
    },
    factcheck: (state, getters) => {
      return getters.session_checklist.map(({ checkresult }) => {
        return checkresult
      })
    },
    newsStates: (state) => {
      return state.session_article_state
    },
    sectionStates: (state) => {
      return state.session_section_state
    },
    get_totalpoint: (state) => {
      return state.totalpoint
    },
    get_totaltime: (state) => {
      return state.totaltime
    },
    get_levelid: (state) => {
      return state.levelid
    },
    articles_foredit: (state) => {
      return state.articles_foredit.map(({ id, tag }) => {
        if (tag == '#happy') {
          return {
            id,
            title: state.articles[id - 1].title,
            title_sub: state.articles[id - 1].title_sub,
            section: state.articles[id - 1].section,
            word: state.articles[id - 1].word,
            hashtag: '#감동적인',
          }
        }
        else if (tag == '#hope') {
          return {
            id,
            title: state.articles[id - 1].title,
            title_sub: state.articles[id - 1].title_sub,
            section: state.articles[id - 1].section,
            word: state.articles[id - 1].word,
            hashtag: '#흥미로운',
          }
        }
        else if (tag == '#frustration') {
          return {
            id,
            title: state.articles[id - 1].title,
            title_sub: state.articles[id - 1].title_sub,
            section: state.articles[id - 1].section,
            word: state.articles[id - 1].word,
            hashtag: '#안타까움',
          }
        }
        else if (tag == '#sad') {
          return {
            id,
            title: state.articles[id - 1].title,
            title_sub: state.articles[id - 1].title_sub,
            section: state.articles[id - 1].section,
            word: state.articles[id - 1].word,
            hashtag: '#답답힘',
          }
        }
        else {
          return {
            id,
            title: state.articles[id - 1].title,
            title_sub: state.articles[id - 1].title_sub,
            section: state.articles[id - 1].section,
            word: state.articles[id - 1].word,
            hashtag: '#기타',
          }
        }
      })
    },
    article_forsend: (state) => {
      return state.articles_foredit.map(({ id, tag }) => {
        if (tag == '#happy') {
          let tagid = 0
          return `${id}.${tagid}.0`
        }
        else if (tag == '#hope') {
          let tagid = 1
          return `${id}.${tagid}.0`
        }
        else if (tag == '#sad') {
          let tagid = 3
          return `${id}.${tagid}.0`
        }
        else if (tag == '#frustration') {
          let tagid = 4
          return `${id}.${tagid}.0`
        }
        else {
          let tagid = 2
          return `${id}.${tagid}.0`
        }
      })
    }
  },
  actions: {
    sendUserinfo({ commit, state }) {
      axios.get(URLsession3('register', state.user_email, state.user_name, state.user_age))
        .then(({ data }) => {
          if (data.type == 'create') {
            commit('SetPlayerid', data.result)
          }
          else {
            commit('SetPlayerid', data.result)
          }
        })
    },
    sendUserSection({ commit, getters }, Newsection) {
      commit('updateSectionid', Newsection)
      axios
        .get(URLsession2('section', getters.session_PE, Newsection))
        .then(({ data }) => commit('update_session_section', data.result))
        .catch(error => { console.log(error.response) })
    },
    sendUserArticle({ commit, getters }, Newarticle) {
      commit('updateArticleid', Newarticle)
      axios
        .get(URLsession2('article', getters.session_section, Newarticle))
        .then(({ data }) => commit('update_session_article', data.result))
        .catch(error => { console.log(error.response) })
    },
    sendUserCode({ commit, getters, state }, payload) {
      commit('updateCode', payload.code)
      const current_clue = getters.current_clue
      if (current_clue.id == null || payload.typeloca == "") {
        console.log("clue is null")
      }
      else {
        axios
          .get(URLsession3('createclue', getters.session_article, current_clue.id, payload.typeloca))
      }
    },
    prevcodedel({ getters }, type) {
      axios
        .get(URLsession2('deleteclue', getters.session_article, type))
    },
    deleteallclue({ getters }) {
      axios
        .get(URLsession('deleteallclue', getters.session_article))
    },
    sendhashtag({ commit, getters }, newtag) {
      axios
        .get(URLsession2('newtag', getters.session_article, newtag))
    },
    sendPoint({ commit, getters }, Newpoint) {
      axios
        .get(URLsession3('point', getters.session_PE, getters.session_article, Newpoint))
        .then(res => res.data)
        .then(newPoint => { commit('increment_point', newPoint.result) })
    },
    sendPointdouble({ commit, getters }, Newpoint) {
      axios
        .get(URLsession3('double', getters.session_section, getters.session_article, Newpoint))
        .then((res) => res.data)
        .then(newPoint => { commit('increment_point', newPoint.result) })
    },
    loadUserinfo({ commit, getters }) {
      axios
        .get(URLgetid('session', 'players', getters.session_player))
        .then(res => res.data)
        .then(({ name }) => {
          commit('SetUsername', name)
        })
    },
    loadArticles({ commit }) {
      axios
        .get(URL('game', 'articles'))
        .then(res => res.data)
        .then(articles => { commit('SetArticles', articles) })
    },
    loadLinksArticle({ commit }) {
      axios
        .get(URL('game', 'links'))
        .then(res => res.data)
        .then(links => { commit('SetlinkArticle', links) })
    },
    loadClues({ commit }) {
      axios
        .get(URL('game', 'clues'))
        .then(res => res.data)
        .then(clues => { commit('SetClues', clues) })
    },
    loadfwoh({ commit }) {
      axios
        .get(URL('game', '5w1h'))
        .then(res => res.data)
        .then(fwoh => { commit('Setfwoh', fwoh) })
    },
    loadhashtag({ commit }, current_article_id) {
      axios
        .get(URLsession('hashtag', current_article_id))
        .then(({ data }) => { commit('SetHashtag', data) })
    },
    loadArticleState({ commit, getters }, game_section) {
      axios
        .get(URLsession2('iscomplete', getters.session_PE, game_section))
        .then(res => res.data)
        .then(article_state => {
          commit('SetArticlestate', article_state)
        })
    },
    loadfwohlist({ commit, getters }, article_id) {
      axios
        .get(URLsession2('fwohlist', article_id, getters.session_section))
        .then(res => res.data)
        .then(fwohlist => { commit('Setfwohlist', fwohlist) })
    },
    loadChecklist({ commit, getters }) {
      axios
        .get(URLsession2('checking', getters.current_article_id, getters.session_section))
        .then(res => res.data)
        .then(checklist => { commit('Setchecklist', checklist) })
    },
    loadTotalpoint({ commit, getters }) {
      axios
        .get(URLsession('totalpoint', getters.session_PE))
        .then(res => res.data)
        .then(totalpoint => { commit('SetTotalpoint', totalpoint.result) })
    },
    loadTime({ commit, getters }) {
      axios
        .get(URLsession('time', getters.session_PE))
        .then(res => res.data)
        .then(totaltime => { commit('SetTotaltime', totaltime.result) })
    },
    loadSectionState({ commit, getters }) {
      axios
        .get(URLsession('badge', getters.session_PE))
        .then(res => {
          commit('SetSecionState', res.data)
        })
    },
    loadforEditArticle({ commit, getters }) {
      axios
        .get(URLsession('edit', getters.session_PE))
        .then(res => res.data)
        .then(articles => { commit('SetforeditArticles', articles) })
    }
  },
  mutations: {
    updateSectionid(state, section) {
      state.current_section_id = section
    },
    update_session_section(state, session_section) {
      state.session_section = session_section
    },
    updateArticleid(state, article) {
      state.current_article_id = article
    },
    update_session_article(state, session_article) {
      state.session_article = session_article
    },
    updateCode(state, code) {
      state.current_code = code
    },
    increment_point(state, newPoint) {
      state.totalpoint += parseInt(newPoint)
    },
    updateLevelid(state, levelid) {
      state.levelid = levelid
    },
    SetArticles(state, articles) {
      state.articles = articles
    },
    SetArticlestate(state, article_state) {
      state.session_article_state = article_state
    },
    SetlinkArticle(state, links) {
      state.linkArticles = links
    },
    SetClues(state, clues) {
      state.clues = clues
    },
    Setfwoh(state, fwoh) {
      state.fwoh = fwoh
    },
    Setfwohlist(state, fwohlist) {
      state.session_fwohlist = fwohlist
    },
    SetUsername(state, name) {
      state.user_name = name
    },
    SetUseremail(state, email) {
      state.user_email = email
    },
    SetUserage(state, age) {
      state.user_age = age
    },
    SetUserimg(state, imgurl) {
      state.user_image = imgurl
    },
    SetHashtag(state, hashtag) {
      state.session_hashtag = hashtag
    },
    SetPlayerid(state, playerid) {
      state.session_player = playerid
    },
    Seteventcode(state, eventcode) {
      state.session_eventcode = eventcode
    },
    SetPE(state, PE) {
      state.session_PE = PE
    },
    Setchecklist(state, checklist) {
      state.session_checklist = checklist
    },
    SetTotalpoint(state, totalpoint) {
      state.totalpoint = totalpoint
    },
    timeticken(state) {
      state.totaltime = state.totaltime - 1
    },
    SetTotaltime(state, totaltime) {
      state.totaltime = totaltime
    },
    SetSecionState(state, secionState) {
      state.session_section_state = secionState
    },
    SetforeditArticles(state, articles) {
      state.articles_foredit = articles
    },
    SetinitialState(state) {
      state.user_name = ''
      state.user_email = ''
      state.user_age = ''
      state.user_image = ''
      state.session_eventcode = ''
      state.totaltime = 1800
      state.totalpoint = 0
      state.levelid = 0
    }
  }
})



// WEBPACK FOOTER //
// ./src/store.js